import React, { useCallback, useState } from 'react';
import { UtilityBar } from '../components/layout/UtilityBar';
import { SiteHeader } from '../components/layout/SiteHeader';
import { SiteFooter } from '../components/layout/SiteFooter';
import { Hero } from '../components/sections/Hero';
import { EmpowerSection } from '../components/sections/EmpowerSection';
import { AboutSection } from '../components/sections/AboutSection';
import { StatsSection } from '../components/sections/StatsSection';
import { MentoringSection } from '../components/sections/MentoringSection';
import { VenturesSection } from '../components/sections/VenturesSection';
import { EngageSection } from '../components/sections/EngageSection';
import { ContactSection } from '../components/sections/ContactSection';
import type { Interest } from '../types/contact';
export function Home() {
  const [interest, setInterest] = useState<Interest | ''>('');
  const requestContact = useCallback((value: Interest) => {
    setInterest(value);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.getElementById('contact')?.scrollIntoView({
      behavior: reduce ? 'auto' : 'smooth'
    });
    window.setTimeout(() => document.getElementById('contact-name')?.focus({
      preventScroll: true
    }), reduce ? 0 : 600);
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans" data-id="element-259" data-mp="2mvytfse6wwau">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-white focus:px-5 focus:py-3 focus:font-bold focus:text-brand-navy" data-id="element-260" data-mp="2hxxbjasi330y">
        Skip to content
      </a>
      <UtilityBar data-id="element-261" data-mp="288nle0h7vufh" />
      <SiteHeader data-id="element-262" data-mp="28617zk7nakpc" />
      <main id="main" data-id="element-263" data-mp="239awla6scda9">
        <Hero data-id="element-264" data-mp="239sqi05z6ff0" />
        <EmpowerSection data-id="element-265" data-mp="23ac7nenswzrz" />
        <AboutSection data-id="element-266" data-mp="23aua4t124a8c" />
        <StatsSection data-id="element-267" data-mp="1z7fva5outzwh" />
        <MentoringSection data-id="element-268" data-mp="1z7xsb4jcci5g" />
        <VenturesSection onRequestContact={requestContact} data-id="element-269" data-mp="1z64k3kt2xpvc" />
        <EngageSection onRequestContact={requestContact} data-id="element-270" data-mp="1u7t7517hmz8w" />
        <ContactSection interest={interest} onInterestChange={setInterest} data-id="element-271" data-mp="1uafqdy3qr36y" />
      </main>
      <SiteFooter data-id="element-272" data-mp="1kjfjffn3d6nd" />
    </div>;
}